module.exports = __webpack_public_path__ + "img/jpyc11.cecd90e9.png";